require("babel-polyfill")
require("./boostrap")
import "moment-timezone"
import "fullcalendar"
import "datatables.net"
import "datatables.net-bs4"
import "datatables.net-responsive"
import "datatables.net-responsive-bs4"
import "datatables.net-fixedheader"
import "datatables.net-buttons"
import "datatables.net-buttons-bs4"
import "datatables.net-plugins/sorting/datetime-moment.js"
import "typeahead.js"
import "livestamp"
import "intl-tel-input"
import "intl-tel-input/build/js/utils"
import "jquery-mask-plugin"
import "jquery.dirtyforms"
import Bloodhound from "typeahead.js"
import swal from "sweetalert"
import flatpickr from "flatpickr"
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate"
import rangePlugin from "flatpickr/dist/plugins/rangePlugin"
import autosize from "autosize"
import Uri from "jsuri"
import * as Sentry from "@sentry/browser"
import Tags from "bootstrap5-tags"
import {
	RRule,
	Frequency
} from 'rrule'

Sentry.init({
	dsn: window.Laravel.sentry.dsn
})

window.confirmDatePlugin = confirmDatePlugin
window.rangePlugin = rangePlugin
window.RRule = RRule
window.Frequency = Frequency

$(function () {

	$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
		if (thrownError == 'Unauthorized') {
			location.reload()
		}
	})

	Tags.init("select.tagsinput")
	$.fn.extend({
		insertAtCaret: function (myValue) {
			this.each(function () {
				if (document.selection) {
					this.focus()
					var sel = document.selection.createRange()
					sel.text = myValue
					this.focus()
				} else if (this.selectionStart || this.selectionStart == "0") {
					var startPos = this.selectionStart
					var endPos = this.selectionEnd
					var scrollTop = this.scrollTop
					this.value = this.value.substring(0, startPos) + myValue + this.value.substring(endPos, this.value.length)
					this.focus()
					this.selectionStart = startPos + myValue.length
					this.selectionEnd = startPos + myValue.length
					this.scrollTop = scrollTop
				} else {
					this.value += myValue
					this.focus()
				}
			})
			return this
		}
	})
	$.fn.modal.Constructor.prototype._enforceFocus = function () { }
	$.extend($.fn.dataTable.defaults, {
		language: {
			processing: '<div><span class="fas fa-circle-notch fa-3x fa-spin"></span></div>'
		}
	})
	$.fn.dataTable.moment("MM/DD/YYYY")

	$.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
		new Noty({
			type: "error",
			text: message
		}).show()
	}

	window.setupControls()

	jQuery(window).on("resize orientationchange", function () {
		window.refreshControls()

		$($.fn.dataTable.tables(true)).css("width", "100%")
		$($.fn.dataTable.tables(true)).DataTable().columns.adjust().draw()
	})

	window.Echo.private("App.User." + window.Laravel.userId).notification(function (notification) {
		var buttons = []

		_.each(notification.actions, function (action) {
			buttons.push(Noty.button(
				action.title, "btn btn-xs btn-outline-" + action.class,
				function ($noty) {
					if (action.type == "ajax") {
						NProgress.start()
						axios.get(route(action.route, notification.id)).then(function (response) {
							new Noty({
								type: "success",
								text: response.data.message
							}).show()

							refreshNotifications()
							refreshEvents()

							$noty.close()
							NProgress.done()
						}).catch(function (error) {
							if (error.response) {
								if (error.response.status == 278) {
									window.location = error.response.redirect_url
									return
								} else if (error.response.status == 403) {
									new Noty({
										type: "error",
										text: error.response.data.message
									}).show()
									return
								}
							}

							NProgress.done()
						})
					}
				}, {
				id: "button-" + action.route,
				"data-toggle": "notifications-" + action.type,
				href: route("notifications." + action.route, notification.id)
			}))
		})

		new Noty({
			timeout: false,
			text: "<strong>" + notification.title + "</strong><br/>" + notification.body,
			buttons: buttons,
			callbacks: {
				onClick: function () {
					if (notification.object.quick_view_type == "link") {
						window.location = route(notification.object.route, notification.object.id)
					} else if (notification.object.quick_view_type == "modal") {
						var link = $('<a data-link="ajax-form" style="display: none;"></a>')
						link.prop("href", notification.object.route)
						$("main").append(link)
						link[0].click()
						link.remove()
					}
				}
			},
		}).show()

		refreshEvents()
		refreshTables()
		refreshNotifications()
	})

	// Quick Search
	$("#query,#query-mobile").typeahead({
		minLength: 0,
		async: true,
		highlight: true,
		hint: false,
		showDefault: false
	}, {
		name: "customers",
		display: "name",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/customers/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Customers</h5>",
			suggestion: function (suggestion) {
				return "<div>" + suggestion.name + " (" + suggestion.id + ")</div>"
			}
		}
	}, {
		name: "vendors",
		display: "name",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/vendors/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Vendors</h5>",
			suggestion: function (suggestion) {
				return "<div>" + suggestion.name + " (" + suggestion.id + ")</div>"
			}
		}
	}, {
		name: "products",
		display: "name",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/products/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Products</h5>",
			suggestion: function (suggestion) {
				return "<div>" + suggestion.name + " (" + suggestion.id + ")</div>"
			}
		}
	}, {
		name: "contacts",
		display: "name",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/contacts/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Contacts</h5>",
			suggestion: function (suggestion) {
				return "<div>" + suggestion.name + " (" + suggestion.id + ")</div>"
			}
		}
	}, {
		name: "locations",
		display: "name",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/locations/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Locations</h5>",
			suggestion: function (suggestion) {
				return "<div>" + suggestion.name + " (" + suggestion.id + ")</div>"
			}
		}
	}, {
		name: "orders",
		display: "po",
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.nonword,
			queryTokenizer: Bloodhound.tokenizers.nonword,
			identify: function (suggestion) {
				return suggestion.id
			},
			sufficient: Infinity,
			remote: {
				url: "/orders/search?query=%QUERY",
				wildcard: "%QUERY",
				cache: false,
				filter: function (suggestions) {
					return suggestions
				}
			}
		}),
		limit: Infinity,
		templates: {
			header: "<h5>Orders</h5>",
			suggestion: function (suggestion) {
				return ("<div>" + suggestion.po + " (ordered on: " + moment(suggestion.created_at).format("MM/DD/YYYY") + ")<br><small><em>" + suggestion.items.map(function (value) {
					return value.product.name
				}).join(";") + "</em></small></div>")
			}
		}
	})
		.on("typeahead:select", function (event, suggestion) {
			if (suggestion.quick_view_type == "link") {
				window.location = suggestion.route
			} else if (suggestion.quick_view_type == "modal") {
				var link = $('<a data-link="ajax-form" style="display: none;"></a>')
				link.prop("href", suggestion.route)
				$("main").append(link)
				link[0].click()
				link.remove()
			}

			return false
		})
		.on('typeahead:asyncrequest', function (event) {
			$('.search .fas').show()
		})
		.on('typeahead:asyncreceive', function (event) {
			$('.search .fas').hide()
		})

	$('[data-toggle="clipboard"]').each(function () {
		clipboard = new ClipboardJS($(this)[0])

		clipboard
			.on('success', function (e) {
				new Noty({
					type: "success",
					text: "Copied to clipboard!"
				}).show()
			})
			.on('error', function (e) {
				new Noty({
					type: "error",
					text: "Error copying to clipboard!"
				}).show()
			})
	})

	$("select").each(function () {
		if ($(this).closest('.input-group-append, .flatpickr-calendar, .dataTables_wrapper').length == 0) {
			if ($(this).parent().hasClass('bootstrap-select')) {
				$(this).selectpicker('refresh')
			} else {
				$(this).selectpicker({
					selectOnTab: true,
					showTick: true,
					actionsBox: true,
					style: 'btn-outline-dark',
					header: 'Select an Option',
					noneSelectedText: ''
				})
			}
		}
	})

	$(".navbar").on("click", ".sidebar-toggle", function () {
		if ($(".sidebar").css('display') === 'none') {
			$('.sidebar').attr('style', 'display:block !important')
		}
		else {
			$('.sidebar').attr('style', 'display:none !important')
		}
	})

	$("body").on("click", '[data-toggle="notifications-ajax"]', function (event) {
		event.preventDefault()
		event.stopPropagation()

		var $this = $(this)
		NProgress.start()
		axios.get($this.attr("href")).then(function (response) {
			new Noty({
				type: "success",
				text: response.data.message
			}).show()

			refreshNotifications()

			NProgress.done()
		}).catch(function (error) {
			if (error.response) {
				if (error.response.status == 278) {
					window.location = error.response.redirect_url
					return
				} else if (error.response.status == 403) {
					new Noty({
						type: "error",
						text: error.response.data.message
					}).show()
					return
				}
			}
			NProgress.done()
		})

		return false
	})

	$("body").on("click", '[data-link="ajax-form"]', function (event) {
		event.preventDefault()
		event.stopPropagation()

		var count = $("#form-modal").data("cloned-count") ? $("#form-modal").data("cloned-count") : 0
		var $modal = $("#form-modal").clone(true, true)

		$modal.attr("id", "form-modal-clone-" + ++count)
		$("#form-modal").data("cloned-count", count)
		$modal.insertAfter($(".modal").last())

		openForm($(this).attr("href"), $modal)
	})

	$("body").on("click", '[data-link="ajax-modal"]', function (event) {
		event.preventDefault()
		event.stopPropagation()

		var count = $("#link-modal").data("cloned-count") ? $("#link-modal").data("cloned-count") : 0
		var $modal = $("#link-modal").clone(true, true)

		$modal.attr("id", "link-modal-clone-" + ++count)
		$("#link-modal").data("cloned-count", count)
		$modal.insertAfter($(".modal").last())

		openLink($(this).attr("href"), $modal)
	})

	$("body").on("click", '[data-link="ajax-link"]', function (event) {
		event.preventDefault()
		event.stopPropagation()

		var $this = $(this)

		NProgress.start()
		axios.get($this.attr("href")).then(function (response) {
			if (response.status == 278) {
				new Noty({
					type: "success",
					text: response.data.message
				}).show()

				setTimeout(function () {
					window.location = response.data.redirect_url
					return
				}, 500)
			} else {
				if (response.data.error == true) {
					new Noty({
						type: "error",
						text: response.data.message
					}).show()
				} else {
					new Noty({
						type: "success",
						text: response.data.message
					}).show()

					refreshEvents()
					refreshTables()
				}
			}
			NProgress.done()
		}).catch(function (error) {
			if (error.response) {
				switch (error.response.status) {
					case 278:
						window.location = response.redirect_url
						return
					case 403:
						new Noty({
							type: "error",
							text: error.response.data.message
						}).show()
						return
				}
			}
			NProgress.done()
		})
	})

	$("body").on("submit", 'form[data-link="ajax-confirm"]', function (event) {
		event.preventDefault()
		var $form = $(this)
		var $modal = $(this).closest(".modal")
		$modal.data("confirmed", true)

		swal({
			title: "Are you sure?",
			text: "You will not be able to recover that data!",
			icon: "warning",
			buttons: [
				"No", "Yes"
			],
			dangerMode: true
		}).then(value => {
			if (value) {
				var data = new FormData($(this)[0])

				NProgress.start()
				axios({
					method: $form.attr("method"),
					url: $form.attr("action"),
					data: data
				}).then(function (response) {
					if (response.status == 278) {
						window.location = response.data.redirect_url
						return
					} else {
						if (response.data.error == true) {
							new Noty({
								type: "error",
								text: response.data.message
							}).show()
						} else {
							new Noty({
								type: "success",
								text: response.data.message
							}).show()

							$modal.modal("hide")
							refreshEvents()
							refreshTables()

							if (response.data.filter_element != 'undefined') {
								setTimeout(function () {
									$form.closest(response.data.filter_element).remove()
								}, 500)
							}
						}
					}
					NProgress.done()
				}).catch(function (error) {
					if (error.response) {
						switch (error.response.status) {
							case 278:
								window.location = response.redirect_url
								return
							case 403:
								new Noty({
									type: "error",
									text: error.response.data.message
								}).show()
								return
							case 422:
								new Noty({
									type: "error",
									text: error.response.data.message
								}).show()
								break
						}
					}
					NProgress.done()
				})
			}
		})
	})

	$("body").on("click", '.modal button[type="submit"]:not(.delete)', function (event) {
		event.preventDefault()
		event.stopPropagation()

		var $modal = $(this).closest(".modal")

		$("form:not(.delete-form)", $modal).data("action", $(this).val()).trigger("submit")
	})

	$("#loading-loader").removeClass("is-active")
})

window.setupControls = function (object = null) {
	var $object = object === null ? $("main") : $(object)

	$(".tooltip").tooltip("hide")

	$('[data-toggle="tooltip"]', $object).tooltip()
	$('[data-toggle="popover"]', $object).popover({
		trigger: "click",
		html: true,
		sanitize: false
	})
	$('[data-toggle="clipboard"]', $object).each(function () {
		new ClipboardJS(this)
	})
	$("input[type='number']", $object).each(function () {
		if ($(this).siblings('.input-group').length == 0) {
			$(this).inputSpinner()
		}
	})

	$("textarea", $object).each(function () {
		autosize(this)
	}).on("autosize:resized", function () {
		if ($(this).parents(".modal").length > 0) {
			$(this).parents(".modal").modal("handleUpdate")
		}
	})

	$("select", $object).each(function () {
		if ($(this).closest('.input-group-append, .flatpickr-calendar, .dataTables_wrapper').length == 0) {
			if ($(this).parent().hasClass('bootstrap-select')) {
				var value = $(this).val()
				$(this).selectpicker('refresh')
				$(this).selectpicker('val', value)
			} else {
				$(this).selectpicker({
					selectOnTab: true,
					showTick: true,
					actionsBox: true,
					style: 'btn-outline-dark',
					header: 'Select an Option',
					noneSelectedText: ''
				})
			}

			if ($(this).attr("name") == "country") {
				$(this).on("change", function () {
					axios
						.get(route("locations.states", {
							country: $(this).val()
						}))
						.then(function (response) {
							var $states = $('select[name="region"]', $object)
							$states.find("option").remove().end().append("<option></option>")

							_.forEach(response.data, function (value, key) {
								var $option = $("<option></option>").html(value).val(key)

								$states.find("option").end().append($option)
							})
							$states.val('')

							if ($states.parent().hasClass('bootstrap-select')) {
								$states.selectpicker('refresh')
							} else {
								$states.selectpicker({
									selectOnTab: true,
									showTick: true,
									actionsBox: true,
									style: 'btn-outline-dark',
									header: 'Select an Option',
									noneSelectedText: ''
								})
							}
						})
				})
			}
		}
	})

	$('[type="phone"]', $object).intlTelInput({
		autoHideDialCode: false,
		autoPlaceholder: false,
		initialCountry: "US",
		preferredCountries: [
			"US", "CA", "MX", "GB"
		],
		separateDialCode: true,
		nationalMode: true
	})
	$('[type="phone"]', $object).on("countrychange", function (event, countryData) {
		$(event.target).mask($(event.target).attr("placeholder").replace(/[0-9]/g, "0"))
	})

	$('[type="x-tmpl-mustache"]', $object).each(function () {
		Mustache.parse($(this).html())
	})

	$("[data-transform]", $object).each(function () {
		var $this = $(this)

		if ($this.val() != $this.attr("data-default-date")) {
			$this.attr("data-default-date", $this.val())
		}

		switch ($this.data("transform")) {
			case "date":
				$this.data("flatpickr", flatpickr($this[0], {
					enableTime: false,
					dateFormat: "m/d/Y",
					allowInput: true,
					minDate: $this.data("minDate") ? $this.data("minDate") : "today",
					onChange: function (selectedDates, dateStr, instance) {
						if ($this.data("onChange")) {
							$this.data("onChange")(selectedDates, dateStr, instance)
						}
					},
					plugins: [new confirmDatePlugin({})]
				}))
				break
			case "datetime":
				$this.data("flatpickr", flatpickr($this[0], {
					enableTime: true,
					dateFormat: "m/d/Y h:i K",
					minDate: $this.data("minDate") ? $this.data("minDate") : "today",
					onChange: function (selectedDates, dateStr, instance) {
						if ($this.data("onChange")) {
							$this.data("onChange")(selectedDates, dateStr, instance)
						}
					},
					plugins: [new confirmDatePlugin({})]
				}))
				break
			case "time":
				$this.data("flatpickr", flatpickr($this[0], {
					enableTime: true,
					noCalendar: true,
					dateFormat: "h:i K",
					minDate: $this.data("minDate") ? $this.data("minDate") : "today",
					onChange: function (selectedDates, dateStr, instance) {
						if ($this.data("onChange")) {
							$this.data("onChange")(selectedDates, dateStr, instance)
						}
					},
					plugins: [new confirmDatePlugin({})]
				}))
				break
		}
	})

	if ($(".filters", $object).length > 0) {
		var $filters = $(".filters", $object)
		$filters.on("click", ".toggle", function () {
			var $filters = $(this).closest(".filters")
			$filters.toggleClass("open")
			$filters.find('input[name="open"]').each(function () {
				$(this).val(
					$filters.hasClass("open") ?
						"open" :
						"")
			})
		})

		if ($('[name="date"]', $filters).length > 0) {
			$('[name="date"]', $filters).change(function () {
				$('[class*="date-"]', $filters).hide()
				if ($(this).val() != "all") {
					$(".date-" + $(this).val(), $filters).show()
				}

				window.destroyControls($filters)
				window.setupControls($filters)
			})

			$('[class*="date-"]', $filters).hide()
			if ($('[name="date"]', $filters).val() != "all") {
				$(".date-" + $('[name="date"]', $filters).val(), $filters).show()
			}

			$('[name="start-date"]', $filters).each(function () {
				var $this = $(this)

				if ($this.val() != $this.attr("data-default-date")) {
					$this.attr("data-default-date", $this.val())
				}

				$this.data("flatpickr", flatpickr($this[0], {
					enableTime: false,
					dateFormat: "m/d/Y",
					plugins: [
						new confirmDatePlugin({}),
						new rangePlugin({
							input: '[name="end-date"]'
						})
					]
				}))
			})
		}

		if ($('[name="location"]', $filters).length > 0) {
			$('[name="location"]', $filters).change(function () {
				$('[class*="location-"]', $filters).hide()
				if ($(this).val() != "all") {
					$(".location-" + $(this).val(), $filters).show()
				}

				window.destroyControls($filters)
				window.setupControls($filters)
			})

			$('[class*="location-"]', $filters).hide()
			if ($('[name="location"]', $filters).val() != "all") {
				$(".location-" + $('[name="location"]', $filters).val(), $filters).show()
			}

			$('[name="start-date"]', $filters).each(function () {
				var $this = $(this)

				$this.data("flatpickr", flatpickr($this[0], {
					enableTime: false,
					dateFormat: "m/d/Y",
					plugins: [
						new confirmDatePlugin({}),
						new rangePlugin({
							input: '[name="end-date"]'
						})
					]
				}))
			})
		}
	}
}

window.destroyControls = function (object = null) {
	var $object = object === null ? $("main") : $(object)

	$("select", $object).each(function () {
		$(this).selectpicker('destroy')
	})

	$("input[type='number']", $object).each(function () {
		$(this).inputSpinner('destroy')
	})

	$('[data-transform="date"],[data-transform="datetime"],[data-transform="time"]', $object).each(function () {
		var $this = $(this)

		if ($this.data("flatpickr")) {
			$this.data("flatpickr").destroy()
			$this.data("flatpickr", null)
		}
	})

	$('[type="phone"]', $object).intlTelInput("destroy")
}

window.refreshNotifications = function () {
	axios
		.get(route("notifications")).then(function (response) {
			$("#notifications").html(response.data)
		})
		.catch(function (error) {
			if (error.response) {
				if (error.response.status == 278) {
					window.location = error.response.redirect_url
					return
				} else if (error.response.status == 403) {
					new Noty({
						type: "error",
						text: error.response.data.message
					}).show()
					return
				}
			}
			NProgress.done()
		})
}

window.refreshEvents = function () {
	if ($("#calendar").length > 0) {
		$("#calendar").fullCalendar("refetchEvents")
	}
}

window.refreshTables = function () {
	if (typeof window.LaravelDataTables != "undefined") {
		$(".tooltip").tooltip("hide")
		window.LaravelDataTables["dataTableBuilder"].ajax.reload()
		window.LaravelDataTables["dataTableBuilder"].draw("full-hold")
	}
}

window.refreshControls = function () {
	window.destroyControls()
	window.setupControls()
}

window.downloadFromUrl = function (url, params) {
	var xhr = new XMLHttpRequest()
	xhr.open('GET', url, true)
	xhr.responseType = 'arraybuffer'
	xhr.onload = function () {
		if (this.status === 200) {
			var filename = ""
			var disposition = xhr.getResponseHeader('Content-Disposition')
			if (disposition && disposition.indexOf('attachment') !== -1) {
				var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
				var matches = filenameRegex.exec(disposition)
				if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '')
			}
			var type = xhr.getResponseHeader('Content-Type')

			var blob = new Blob([this.response], {
				type: type
			})
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, filename)
			} else if (window.navigator && window.navigator.msSaveBlob) {
				window.navigator.msSaveBlob(blob, filename)
			} else {
				var URL = window.URL || window.webkitURL
				var downloadUrl = URL.createObjectURL(blob)
				var a = document.createElement("a")

				if (filename) {
					if (typeof a.download === 'undefined') {
						window.location = downloadUrl
					} else {
						a.href = downloadUrl
						a.download = filename
						document.body.appendChild(a)
						a.click()
					}
				} else {
					window.location = downloadUrl
				}

				setTimeout(function () {
					URL.revokeObjectURL(downloadUrl)
					a.remove()
				}, 100)
			}
		}
	}
	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
	xhr.send($.param(params))
}

window.openForm = function ($href, $modal) {
	NProgress.start()

	var uri = new Uri($href)
	uri.addQueryParam("nocache", new Date().getTime())

	axios.get(uri.toString()).then(function (response) {
		NProgress.done()

		$(".modal-title", $modal).html(response.headers["title"])
		$(".modal-body", $modal).html(response.data)
		$(".modal-dialog", $modal).removeClass("modal-sheet")
		$(".btn-group.show,.dropdown-menu.show", $modal).removeClass("show")

		if (response.headers["delete-action"]) {
			$(".delete", $modal).show()
			$(".delete-form", $modal).attr("action", response.headers["delete-action"])
		}

		if (response.headers["size"] == "sheet") {
			$(".modal-dialog", $modal).addClass("modal-sheet")

			var sheetModalCount = $(".modal-sheet").length
			$(".modal-dialog", $modal).css("height", "calc(100vh - " + (
				50 + sheetModalCount * 15) + "px)").css("minHeight", "calc(100vh - " + (
					50 + sheetModalCount * 15) + "px)")

			$modal.css("zIndex", 1050 + sheetModalCount)
		}

		$(".save", $modal).hide()
		if (response.headers["next-actions"]) {
			$(".custom-action", $(".save.multiple", $modal)).remove()

			if (response.headers["next-actions"] !== "hide") {
				var actions = $.parseJSON(response.headers["next-actions"])

				_.forEach(actions, function (value, key) {
					var $button = $('<button type="submit" class="dropdown-item custom-action" name="action" value="' + key + '">' + value + "</button>")
					$(".dropdown-menu", $(".save.multiple", $modal)).append($button)
				})

				$(".save.multiple", $modal).show()
			}
		} else {
			$(".save.single", $modal).show()
		}

		var $form = $("form:not(.delete-form)", $modal)
		$form.dirtyForms({
			message: "Are you sure? The changes you have made will be lost!"
		})

		$form.on("submit", function (event) {
			$(window).unbind('beforeunload')
			event.preventDefault()
			var data = new FormData($(this)[0])
			data.append("action", $(this).data("action"))

			NProgress.start()
			axios({
				method: $form.attr("method"),
				url: $form.attr("action"),
				data: data
			}).then(function (response) {
				NProgress.done()
				if (response.status == 278) {
					new Noty({
						type: "success",
						text: response.headers["message"]
					}).show()

					refreshEvents()
					refreshTables()

					$modal.data("confirmed", true)
					$modal.off("shown.bs.modal")
					$modal.off("hidden.bs.modal")
					$modal
						.on("hidden.bs.modal", function () {
							$modal.off("hidden.bs.modal")
							if (typeof response.headers["redirect-type"] != "undefined" && response.headers["redirect-type"] == "full" && window.location.href != response.data.redirect_url) {
								var link = $('<a style="display: none;"></a>')
								link.prop('href', response.data.redirect_url)
								$('main').append(link)
								link[0].click()
								link.remove()
							} else if (typeof response.headers["redirect-type"] != "undefined" && response.headers["redirect-type"] == "download" && window.location.href != response.data.redirect_url) {
								downloadFromUrl(response.data.redirect_url, {})
							} else if (typeof response.headers["redirect-type"] != "undefined" && response.headers["redirect-type"] == "full" && window.location.href == response.data.redirect_url) {
								$form.dirtyForms("setClean")
								$modal.modal("hide")

								return
							} else if (typeof response.headers["redirect-type"] != "undefined" && response.headers["redirect-type"] == "refresh" && window.location.href == response.data.redirect_url) {
								var link = $('<a style="display: none;"></a>')
								link.prop('href', response.data.redirect_url)
								$('main').append(link)
								setTimeout(function () {
									link[0].click()
									link.remove()
								}, 500)
							} else {
								openForm(response.data.redirect_url, $modal)
							}
						})

					$form.dirtyForms("setClean")
					$modal.modal("hide")
				} else {
					if (response.data.error == true) {
						new Noty({
							type: "error",
							text: response.data.message
						}).show()
					} else {
						new Noty({
							type: "success",
							text: response.data.message
						}).show()

						refreshEvents()
						refreshTables()

						$modal.data("confirmed", true)
						$modal.off("shown.bs.modal")
						$form.dirtyForms("setClean")
						$modal.modal("hide")
					}
				}
			}).catch(function (error) {
				NProgress.done()

				if (error.response) {
					switch (error.response.status) {
						case 403:
							new Noty({
								type: "error",
								text: error.response.data.message
							}).show()
							return
						case 422:
							new Noty({
								type: "error",
								text: error.response.data.message
							}).show()

							$form.removeClass("was-validated")
							$form.find(":input").removeClass("is-invalid")
							$form.find(".form-group,.form-label-group").removeClass("is-invalid")

							$.each(error.response.data.errors, function (key, value) {
								if (key.indexOf(".") > -1) {
									key = key.replace(/\./, "[").replace(/\./g, "][") + "]"
								}

								var field = $('[name="' + key + '"]')

								if (field.length > 1) {
									field = $(_.first(field)).closest(".form-control")
								}

								var form = field.closest("form")
								var wrapper = field.closest(".form-group,.form-label-group")
								var feedback = $(".invalid-feedback", wrapper)
								var collapse = field.closest(".collapse")

								form.addClass("was-validated")
								field.addClass("is-invalid")
								wrapper.addClass("is-invalid")
								collapse.addClass("show")
								feedback.html(value[0])
							})
							$modal.modal("handleUpdate")
							break
					}
				}
			})
		})

		$modal.modal({
			show: false,
			focus: true,
			keyboard: true,
			backdrop: "static"
		})
			.on("shown.bs.modal", function () {
				window.setupControls($modal)
				$modal.trigger("controls.init")
				Tags.init("select.tagsinput")
				setTimeout(function () {
					$(".modal-backdrop").not(".modal-assigned").addClass("modal-assigned " + $modal.attr("id"))
					$(".modal-backdrop." + $modal.attr("id")).css("zIndex", parseInt($modal.css("zIndex")) - 1)
				})
			})
			.on("hide.bs.modal", function (event) {
				var $form = $("form:not(.delete-form)", $(this))

				if (!$modal.data("confirmed") && $form.dirtyForms("isDirty")) {
					event.preventDefault()
					event.stopImmediatePropagation()

					swal({
						title: "Are you sure?",
						text: "The changes you have made will be lost!",
						icon: "warning",
						buttons: [
							"No", "Yes"
						],
						dangerMode: true
					}).then(value => {
						if (value) {
							$modal.data("confirmed", true)
							$modal.modal("hide")
							return true
						}
					})
				}
			})
			.on("hidden.bs.modal", function () {
				$modal.trigger("controls.destroy")
				destroyControls($modal)
				$modal.remove()

				$('[id^="form-modal-clone"]').each(function () {
					window.setupControls($(this))
					$(this).trigger("controls.init")
				})
			})
			.modal("show")
	}).catch(function (error) {
		NProgress.done()

		if (error.response) {
			if (error.response.status == 403) {
				new Noty({
					type: "error",
					text: error.response.data.message
				}).show()
				return
			}
		}
	})
}

window.openLink = function ($href, $modal) {
	NProgress.start()
	axios.get($href).then(function (response) {
		NProgress.done()

		$(".modal-title", $modal).html(response.headers["title"])
		$(".modal-body", $modal).html(response.data)
		$(".modal-dialog", $modal).removeClass("modal-sheet")
		if (response.headers["size"] == "sheet") {
			$(".modal-dialog", $modal).addClass("modal-sheet")

			var sheetModalCount = $(".modal-sheet").length
			$(".modal-dialog", $modal).css("height", "calc(100vh - " + (
				50 + sheetModalCount * 25) + "px)").css("minHeight", "calc(100vh - " + (
					50 + sheetModalCount * 25) + "px)")

			$modal.css("zIndex", 1050 + sheetModalCount)
		}
		$modal.modal({
			show: false,
			focus: true,
			keyboard: true,
			backdrop: "static"
		}).on("shown.bs.modal", function () {
			window.setupControls($modal)
			$modal.trigger("controls.init")
			setTimeout(function () {
				$(".modal-backdrop").not(".modal-assigned").addClass("modal-assigned " + $modal.attr("id"))
				$(".modal-backdrop." + $modal.attr("id")).css("zIndex", parseInt($modal.css("zIndex")) - 1)
			})
		}).on("hide.bs.modal", function (event) {
			var $form = $("form:not(.delete-form)", $(this))

			if (!$modal.data("confirmed") && $form.dirtyForms("isDirty")) {
				event.preventDefault()
				event.stopImmediatePropagation()

				swal({
					title: "Are you sure?",
					text: "The changes you have made will be lost!",
					icon: "warning",
					buttons: [
						"No", "Yes"
					],
					dangerMode: true
				}).then(value => {
					if (value) {
						$modal.data("confirmed", true)
						$modal.modal("hide")
						return true
					}
				})
			}
		}).on("hidden.bs.modal", function () {
			$modal.trigger("controls.destroy")
			destroyControls($modal)
			$modal.remove()

			$(".modal").each(function () {
				window.setupControls($(this))
				$(this).trigger("controls.init")
			})
		}).modal("show")
	}).catch(function (error) {
		NProgress.done()

		if (error.response) {
			if (error.response.status == 403) {
				new Noty({
					type: "error",
					text: error.response.data.message
				}).show()
				return
			}
		}
	})
}